/// <amd-module name="Traceability/RunView/Common/RunViewCommonService" />
import * as BuildContracts from "Build/Client/Contracts/Build";
import { IBuildRestClient } from "Build/Client/RestClient/Build";
import { IProjectData, ITfsPageService } from "Tfs/Platform/Page";
import { Utilities } from "Traceability/Common/Utilities";
import { IRunViewCommonData, IRunViewCommonService } from "Traceability/RunView/Common/RunViewCommonService.types";
import { localeIgnoreCaseComparer } from "VSS/Core/Util/String";
import { IVssPageContext, VssService } from "VSS/Platform/Context";
import { IVssContributionService } from "VSS/Platform/Contribution";

export abstract class RunViewCommonService<T> extends VssService implements IRunViewCommonService<T> {
    protected abstract dataProviderId: string;
    public abstract hubRouteId: string;

    public get pageData(): IRunViewCommonData<T> {
        return this._data;
    }

    public get projectName(): string {
        return this._currentProject.name;
    }

    public get projectId(): string {
        return this._currentProject.id;
    }

    public get contributionService(): IVssContributionService {
        return this._contributionService;
    }

    public getBuild(projectId: string, runId: number): Promise<BuildContracts.Build> {
        return this._buildClient.getBuild(projectId, runId)
    }

    public _serviceStart(pageContext: IVssPageContext): void {
        super._serviceStart(pageContext);
        this._contributionService = pageContext.getService<IVssContributionService>("IVssContributionService");
        this._initializePageData();
    }

    public _serviceEnd(pageContext: IVssPageContext): void {
        super._serviceEnd(pageContext);
    }

    private _initializePageData() {
        this._buildClient = this.pageContext.getRestClient<IBuildRestClient>("IBuildRestClient");
        const tfsPageService = this.pageContext.getService<ITfsPageService>("ITfsPageService");
        const tfsPageData = tfsPageService.getData();
        if (tfsPageData) {
            this._currentProject = tfsPageData.project || { name: "", id: "" } as IProjectData;
        }
        let pageData = (this._contributionService.getData<IRunViewCommonData<T>>(this.dataProviderId) || {}) as IRunViewCommonData<T>;
        if (!!pageData.primaryArtifactAlias) {
            // order by primaryArtifactAlias and then other artifacts
            (pageData.artifactsData || []).sort((a, b) => localeIgnoreCaseComparer(pageData.primaryArtifactAlias, a && a.artifactVersion && a.artifactVersion.alias) === 0 ? -1 : 1);
        }

        // fill the artifact url for 'view details'
        pageData.artifactsData = Utilities.fillArtifactVersionDisplayUri<T>(this.pageContext, pageData.artifactsData);
        Utilities.setPrimaryArtifactAliasName(pageData.primaryArtifactAlias);

        this._data = pageData;
    }

    private _contributionService: IVssContributionService;
    private _buildClient: IBuildRestClient;
    private _currentProject: IProjectData;
    private _data: IRunViewCommonData<T>;
}
